// @ts-expect-error
import ExceptionsManager from 'react-native/Library/Core/ExceptionsManager';

export default ExceptionsManager;
